var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIconHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.525 11.95a.834.834 0 0 0-1.092.45.833.833 0 0 1-.175.275.831.831 0 0 1-.591.242H3.333a1.667 1.667 0 0 1-1.666-1.667v-2.5a1.667 1.667 0 0 1 1.666-1.666h3.334a.833.833 0 0 1 .591.241c.076.08.136.173.175.275a.835.835 0 0 0 1.542-.641 2.417 2.417 0 0 0-.542-.834 2.5 2.5 0 0 0-1.766-.708H3.333A3.333 3.333 0 0 0 0 8.75v2.5a3.334 3.334 0 0 0 3.333 3.334h3.334a2.5 2.5 0 0 0 1.766-.734 2.5 2.5 0 0 0 .542-.833.833.833 0 0 0-.45-1.067Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10a.833.833 0 0 0 .833.834H15a.833.833 0 0 0 0-1.667H5.833A.833.833 0 0 0 5 10Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 5.417h-3.334a2.5 2.5 0 0 0-1.766.733c-.237.238-.421.521-.542.834a.835.835 0 0 0 1.542.641c.04-.102.099-.195.175-.275a.834.834 0 0 1 .591-.266h3.334a1.667 1.667 0 0 1 1.666 1.666v2.5a1.666 1.666 0 0 1-1.666 1.667h-3.334a.833.833 0 0 1-.591-.242.833.833 0 0 1-.175-.275.835.835 0 0 0-1.542.642 2.5 2.5 0 0 0 .542.833 2.5 2.5 0 0 0 1.766.709h3.334A3.333 3.333 0 0 0 20 11.25v-2.5a3.333 3.333 0 0 0-3.333-3.333Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIconHorizontal);
export default __webpack_public_path__ + "static/media/link-icon-horizontal.fa78a36b067d7b446cb2af962649071e.svg";
export { ForwardRef as ReactComponent };